export default __webpack_public_path__ + "static/media/plus.51ae42ab.svg";